import "./Underline.css";

export default function Underline({ isActive, underlineStyle }) {
  return (
    !isActive && (
      <div className="header-navbar__underline" style={underlineStyle} />
    )
  );
}
